import getCustom from './getCustom'
import getEnv from './getEnv'

const urls = {
  local: `http://localhost:3000`,
  dev: 'https://api.bejusto.com',
  prod: 'https://websites-api.getjusto.com'
}

const env = getEnv()

export default getCustom('api') || urls[env]
